import { BasicsBaseApiV2 } from "../BasicsBaseApiV2";

export class ActReFlowApi extends BasicsBaseApiV2 {

    public get ControllerName(): any {
        return 'actreflow';
    }

    /**
     * 获取没有选择的流程	
     * @param projectId 项目Id
     * @param flowTypeNo 流程类别编号
     * @returns 
     */
    public GetNoSelectedFlow(projectId: number, flowTypeNo: string) {
        return this.runAction("GetNoSelectedFlow-E21-M31-S105", { projectId, flowTypeNo })
    }
}